module.exports = __webpack_public_path__ + "static/media/news-journal-wallstreet-image.5d8fde78.webp";